import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import router from './router'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.prototype.moment = moment
Vue.use(PerfectScrollbar)

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
